import { P2pItemAttribute } from '../../enums';

export interface IMarketplaceNameToShow {
  attribute?: P2pItemAttribute;
  name: string;
}
